<template>
    <div>
        <load-spinner :loading="isLoading" />
        <b-card>
            <!-- Add links here -->
            <!-- don't forget history button -->

            <!-- Assessment tool Student Header -->

            <!-- Observation Report information -->
            <h6><b>Instructions: To complete this report, your supervisor must complete Part B and both your supervisor and yourself must sign Part C before handing back to your assessor.</b></h6>

            <b-card class="my-2" header="Unit">
                {{ enrolment.code }} {{ enrolment.title }}
            </b-card>

            <b-card class="my-2" header="Overview of Unit">
                {{ assessmentToolMain.purpose_of_assessment }}
                <br>
                <br>
                {{ assessmentToolMain.target_group }}
                <br>
                <br>
                {{ assessmentToolMain.exclusions_or_special_conditions }}
            </b-card>

            <!-- Supervisor Name -->
            <div class="py-3">
                <label for="supervisor">Supervisor Name</label>
                <b-form-input
                    id="supervisor"
                    v-model="observationReport.observation_report_signoff_sup_name"
                    aria-describedby="observation_report_signoff_sup_name"
                    placeholder="Supervisor Name"
                    :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_supervisor_sign != '')"
                    :state="states.observation_report_signoff_sup_name ? states.observation_report_signoff_sup_name.state : null"
                    @input="resetState('observation_report_signoff_sup_name')"
                />
                <b-form-invalid-feedback id="observation_report_signoff_sup_name">
                    {{ states.observation_report_signoff_sup_name ? states.observation_report_signoff_sup_name.feedback : '' }}
                </b-form-invalid-feedback>
            </div>

            <!-- Length of supervision of student -->
            <div class="py-3">
                <label for="supervision-length">Length of Supervision of Student</label>
                <b-form-input
                    id="supervision-length"
                    v-model="observationReport.observation_report_signoff_sup_length"
                    aria-describedby="observation_report_signoff_sup_length"
                    placeholder="Length of Supervision of Student"
                    :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_supervisor_sign != '')"
                    :state="states.observation_report_signoff_sup_length ? states.observation_report_signoff_sup_length.state : null"
                    @input="resetState('observation_report_signoff_sup_length')"
                />
                <b-form-invalid-feedback id="observation_report_signoff_sup_length">
                    {{ states.observation_report_signoff_sup_length ? states.observation_report_signoff_sup_length.feedback : '' }}
                </b-form-invalid-feedback>
            </div>

            <b-card class="my-2" header="Advice to Supervisor">
                As a supervisor you are required to:
                <ul>
                    <li>Understand the significance of answering honestly</li>
                    <li>Deal specifically with the Student’s performance</li>
                    <li>Be prepared to provide additional evidence in the form of a report or phone interview</li>
                </ul>
                A copy of the full Competency Standard for this unit can be viewed at <a href='https://training.gov.au/' target="_blank">training.gov.au</a>
            </b-card>

            <b-card class="my-2" header="Instructions for Completion">
                Please tick the box that best shows the Student’s performance in the unit activity described below while working with you.
            </b-card>

            <h4>Individuals must provide evidence that they have worked in an <span style="color: red;">automotive service and repair environment.</span> Individuals must demonstrate that they can:</h4>

            <h5 v-if="strip_tags(assessmentToolMain.demonstration_requirements_caption) != 'na'" v-html="assessmentToolMain.demonstration_requirements_caption"/>
        
            <!-- assessment tool demonstration -->
            <div>
                <div
                    v-for="(demo, i) in assessmentToolMain.assessment_tool_demonstrations"
                    :key="`demo-${i}`"
                    class="row py-3 mb-1 border-bottom"
                >
                    <div class="col-sm-10">
                        {{ i + 1 }} {{ demo.name }}
                    </div>
                    <div class="col-sm-2">
                        <b-form-radio-group
                            :options="[{text: 'Yes', value: 'Yes'}, {text: 'No', value: 'No'}]"
                            v-model="observationReport[`assess_tool_demo_${demo.id}`]"
                            :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_supervisor_sign != '')"
                            :state="states.demos ? states.demos.state : null"
                            size="lg"
                            @input="resetState('demos')"
                        />
                        <b-form-invalid-feedback :state="states.demos ? states.demos.state : true">
                            {{ states.demos ? states.demos.feedback : '' }}
                        </b-form-invalid-feedback>
                    </div>
                </div>
            </div>


            <h4>This section is to be completed by the student and signed by the workplace supervisor when the tasks have been completed in the workplace</h4>
            <h5>Workplace Tasks: Individuals must provide evidence that links them to the vehicles that they have worked on, e.g. Repair Orders.</h5>

            <!-- assessment tool tasks -->
            <div>
                <div
                    v-for="(task, i) in assessmentToolMain.assessment_tool_tasks"
                    :key="`task-${i}`"
                    class="py-3"
                >
                    <div class="row">
                        <div class="col">
                            <b>{{ task.name }}</b>
                            <b-form-textarea
                                :id="`task-text-${i}`"
                                :placeholder="task.name"
                                v-model="observationReport[`task_comment_${task.id}`]"
                                :aria-describedby="`task_comment_${task.id}`"
                                :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_student_sign != '')"
                                :state="states[`task_comment_${task.id}`] ? states[`task_comment_${task.id}`].state : null"
                                @input="resetState(`task_comment_${task.id}`)"
                            />
                            <b-form-invalid-feedback :id="`task_comment_${task.id}`">
                                {{ states[`task_comment_${task.id}`] ? states[`task_comment_${task.id}`].feedback : '' }}
                            </b-form-invalid-feedback>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-6">
                            <label :for="`task-repair-${task.id}`">Repair order No</label>
                            <b-form-input
                                :id="`task-repair-${task.id}`"
                                placeholder="Repair order no"
                                v-model="observationReport[`repair_order_${task.id}`]"
                                :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_student_sign != '')"
                                :state="states[`repair_order_${task.id}`] ? states[`repair_order_${task.id}`].state : null"
                                :aria-describedby="`repair_order_${task.id}`"
                                @input="resetState(`repair_order_${task.id}`)"
                            />
                            <b-form-invalid-feedback :id="`repair_order_${task.id}`">
                                {{ states[`repair_order_${task.id}`] ? states[`repair_order_${task.id}`].feedback : '' }}
                            </b-form-invalid-feedback>
                        </div>
                        <div class="col-sm-6">
                            <label :for="`task-date-${task.id}`">Date</label>
                            <datepicker
                                :id="`task-date-${task.id}`"
                                :input-class="`form-control ${(completed || (assessmentTool && assessmentTool.supervisor_student_signoff_student_sign != '')) ? '' : 'dp-nice'} ${states[`task_repair_date_${task.id}`] ? states[`task_repair_date_${task.id}`].state ? '' : 'is-invalid' : ''}`"
                                :value="setDate(observationReport[`task_repair_date_${task.id}`])"
                                format="dd/MM/yyyy"
                                @selected="setDate($event, `task_repair_date_${task.id}`)"
                                :disabled="completed || (assessmentTool && assessmentTool.supervisor_student_signoff_student_sign != '')"
                                @input="resetState(`task_repair_date_${task.id}`)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Signatures -->
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <h5>Student Signature</h5>
                    <div>
                        <b-checkbox
                            class="mb-2"
                            v-model="studentAcceptance"
                            :disabled="assessmentTool && assessmentTool.supervisor_student_signoff_student_sign != ''"
                        >
                            Apprentice/Trainee must provide evidence such as photos of Job Cards and/or a short 2 minute video of the occassions they have performed tasks against this unit to support the Negotiated Training Plan
                        </b-checkbox>
                    </div>
                    <span
                        v-if="assessmentTool && assessmentTool.supervisor_student_signoff_student_sign"
                        v-html="assessmentTool ? assessmentTool.supervisor_student_signoff_student_sign : ''"
                    />
                    <div v-else>
                        <signature-pad-component
                            v-show="studentAcceptance == false"
                            signature-type="student_signature_disabled"
                            :config="studentSignaturePadDisabledConfig"
                        />
                        <signature-pad-component
                            v-show="studentAcceptance == true"
                            v-model="supervisor_student_signoff_student_sign"
                            ref='studentSignaturePad'
                            signature-type="student_signature"
                        />
                    </div>
                </div>
                <br>
                <div class="col-md-12 col-lg-6">
                    <h5>Supervisor Signature</h5>
                    <div>
                        <b-checkbox
                            class="mb-2"
                            v-model="supervisorAcceptance"
                            :disabled="true"
                        >
                            I have observed the Apprentice/Trainee successfully undertake the workplace tasks of "{{ enrolment.code }} - {{ enrolment.title }}"
                        </b-checkbox>
                    </div>
                    <span
                        v-if="assessmentTool && assessmentTool.supervisor_student_signoff_supervisor_sign"
                        v-html="assessmentTool ? assessmentTool.supervisor_student_signoff_supervisor_sign : ''"
                    />
                    <p v-else>Not Yet Signed</p>
                    <!-- <signature-pad-component
                        v-else
                        v-model="supervisor_student_signoff_supervisor_sign"
                        signature-type="supervisor_signature"
                    /> -->
                </div>
            </div>

            <!-- save and complete buttons -->
            <div class="border-top py-3">
                <div v-if="!completed">
                    <span class="float-left"><b-btn variant="primary" @click="save">Save</b-btn></span>
                </div>
                <div v-else>
                    <b-alert variant="success" show>Section completed by: {{ assessmentTool.supervisor_student_signoff_name }} @ {{ completedDateFormat(assessmentTool.supervisor_student_signoff_date, assessmentTool.supervisor_student_signoff_supervisor_sign_date) }}</b-alert>
                </div>
            </div>

        </b-card>
    </div>
</template>

<script>
import SignaturePadComponent from '../SignaturePadComponent.vue';

export default {
    components: {
        SignaturePadComponent,
    },
    props: {
        assessmentToolMain: {
            type: Object,
            required: true,
        },
        enrolment: {
            type: Object,
            required: true,
        },
    },
    data() {
        // build data object
        let obsRep = {
            observation_report_signoff_sup_name: null,
            observation_report_signoff_sup_length: null,
            save_complete: null,
        };
        this.assessmentToolMain.assessment_tool_demonstrations.forEach((d) => {
            obsRep[`assess_tool_demo_${d.id}`] = null;
        });
        this.assessmentToolMain.assessment_tool_tasks.forEach((t) => {
            obsRep[`repair_order_${t.id}`] = null;
            obsRep[`task_repair_date_${t.id}`] = null;
            obsRep[`task_comment_${t.id}`] = null;
        });
        return {
            isLoading: true,
            assessmentTool: null,
            observationReport: obsRep,
            supervisor_student_signoff_student_sign: '',
            // supervisor_student_signoff_supervisor_sign: '',
            states: {},
            supervisorAcceptance: false,
            studentAcceptance: false,
            studentSignaturePadDisabledConfig: {
                bgColour: '#eeeeee',
                drawOnly: true,
                defaultAction: 'drawIt',
                lineWidth: 0,
                penWidth: 2,
                validateFields: true,
                errorClass: 'alert-danger',
                errorMessageDraw: 'Signature is required!',
                displayOnly: true,
            },
        };
    },
    computed: {
        completed() {
            return this.assessmentTool ? (this.assessmentTool.observation_report_signoff_status == "2" && this.assessmentTool.supervisor_student_signoff_status == "2") : false;
        },
    },
    watch: {
        assessmentTool() {
            this.observationReport = {...this.observationReport, ...JSON.parse(this.assessmentTool.observation_report_signoff ? this.assessmentTool.observation_report_signoff : "{}")};
        },
        studentAcceptance() {
            if (this.studentAcceptance == false && this.$refs.studentSignaturePad) {
                this.$refs.studentSignaturePad.clearSignature();
            }
        }
    },
    mounted() {
        this.fetchAssessmentToolData();
    },
    filters: {
        strip_tags(val) {
            return DOMPurify.sanitize(val, {ALLOWED_TAGS: []});
        },
    },
    methods: {
        resetState(field) {
            Vue.delete(this.states, field);
        },
        save() {
            this.isLoading = true;
            axios
                .put(`/api/assessment-tool/${this.assessmentTool.id}`, {
                    // complete: (this.observationReport.supervisor_student_signoff_supervisor_sign !== '' && this.supervisor_student_signoff_student_sign !== '') ? true : false,
                    ...this.observationReport,
                    supervisor_student_signoff_student_sign: this.assessmentTool.supervisor_student_signoff_student_sign ? undefined : this.supervisor_student_signoff_student_sign,
                    // supervisor_student_signoff_supervisor_sign: this.supervisor_student_signoff_supervisor_sign,
                })
                .then((res) => {
                    const n = new Noty({
                        text: 'Saved!',
                        type: 'success',
                    });
                    n.show();
                    this.assessmentTool = res.data.data;

                    if (this.assessmentTool && this.assessmentTool.supervisor_student_signoff_supervisor_sign) {
                        this.supervisorAcceptance = true;
                    } else {
                        this.supervisorAcceptance = false;
                    }

                    if (this.assessmentTool && this.assessmentTool.supervisor_student_signoff_student_sign) {
                        this.studentAcceptance = true;
                    } else {
                        this.studentAcceptance = false;
                    }
                })
                .catch((e) => {
                    if (e.response && e.response.data.errors) {
                        Object.keys(e.response.data.errors).forEach((field) => {
                            this.states[field] = {
                                state: false,
                                feedback: field === 'demos' ? e.response.data.errors[`${field}`].join(' & ') : 'This field is required',
                            };
                        });
                    }

                    const n = new Noty({
                        text: 'Error saving assessment tool data',
                        type: 'error',
                    });
                    n.show();
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        setDate(d, key) {
            if (key) {
                this.observationReport[key] = moment(d).format('DD/MM/YYYY');
                return;
            }

            if (d === "") {
                return;
            }

            const date = moment(d, 'DD/MM/YYYY');
            if (date.isValid()) {
                return new Date(date.year(), date.month(), date.date());
            }
            return '';
        },
        fetchAssessmentToolData() {
            this.isLoading = true;
            axios
                .get('/api/assessment-tool', {
                    params: {
                        enrolment_id: this.enrolment.id,
                    },
                })
                .then((response) => {
                    this.assessmentTool = response.data.data;
                    if (this.assessmentTool && this.assessmentTool.supervisor_student_signoff_supervisor_sign) {
                        this.supervisorAcceptance = true;
                    } else {
                        this.supervisorAcceptance = false;
                    }

                    if (this.assessmentTool && this.assessmentTool.supervisor_student_signoff_student_sign) {
                        this.studentAcceptance = true;
                    } else {
                        this.studentAcceptance = false;
                    }
                })
                .catch((error) => {
                    const n = new Noty({
                        text: 'Error fetching assessment tool data',
                        type: 'error',
                    });
                    n.show();
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        strip_tags(val) {
            return DOMPurify.sanitize(val, {ALLOWED_TAGS: []});
        },
        completedDateFormat(studentDate, supervisorDate) {
            if (studentDate == null || studentDate == '') {
                return '';
            }

            var mStudentDate;

            if (studentDate.date) {
                mStudentDate = new moment(studentDate.date);
            } else {
                mStudentDate = new moment(studentDate);
            }

            if (supervisorDate == '' || supervisorDate == null) {
                return mStudentDate.format('DD/MM/YYYY hh:mma');;
            }
            
            let mSupervisorDate = new moment(supervisorDate);

            if (mStudentDate.isAfter(mSupervisorDate)) {
                return mStudentDate.format('DD/MM/YYYY hh:mma');
            } else {
                return mSupervisorDate.format('DD/MM/YYYY hh:mma');
            }
        }
    },
};
</script>

<style>
.dp-nice {
    background-color: #fff !important;
}
</style>
